import { TabType } from "../ProfileEditModal";

interface Props {
  sider: TabType;
  label: string;
  activeTab: TabType;
  changeActiveTab: (s: TabType) => void;
}

export default function TabButton({
  sider,
  label,
  activeTab,
  changeActiveTab,
}: Props) {
  return (
    <button
      className={`cabinet_profileeditmodal-left-sidebar-button ${
        activeTab === sider ? "active" : ""
      }`}
      onClick={() => changeActiveTab(sider)}
    >
      {label}
    </button>
  );
}
